import { render, staticRenderFns } from "./receiving-list-comp.vue?vue&type=template&id=e44ad8e0&"
import script from "./js/receiving-list-comp.js?vue&type=script&lang=js&"
export * from "./js/receiving-list-comp.js?vue&type=script&lang=js&"
import style0 from "./receiving-list-comp.vue?vue&type=style&index=0&id=e44ad8e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports